"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "attunedDarkTheme", {
  enumerable: true,
  get: function get() {
    return _darkTheme.default;
  }
});
Object.defineProperty(exports, "attunedLightTheme", {
  enumerable: true,
  get: function get() {
    return _lightTheme.default;
  }
});
exports.generateTheme = void 0;

var _styles = require("@mui/material/styles");

var _common = require("../common");

var _darkTheme = _interopRequireDefault(require("./dark-theme"));

var _lightTheme = _interopRequireDefault(require("./light-theme"));

require("@fontsource/open-sans");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultFontFamily = 'Open Sans, Roboto, Helvetica, Arial, sans-serif';
var intermediaryTheme = (0, _styles.createTheme)();

var generateTheme = function generateTheme(theme, fontSize, overrides) {
  var _h, _pageHeader, _sectionHeader, _body, _body2;

  return (0, _styles.createTheme)((0, _styles.adaptV4Theme)({
    palette: theme,
    typography: {
      fontSize: _common.FONT_MODES[fontSize],
      fontFamily: defaultFontFamily,
      h6: (_h = {
        fontSize: (0, _common.pxToRem)(16)
      }, _defineProperty(_h, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: (0, _common.pxToRem)(15)
      }), _defineProperty(_h, intermediaryTheme.breakpoints.down('md'), {
        fontSize: (0, _common.pxToRem)(14)
      }), _defineProperty(_h, intermediaryTheme.breakpoints.down('sm'), {
        fontSize: (0, _common.pxToRem)(14)
      }), _defineProperty(_h, intermediaryTheme.breakpoints.down('xs'), {
        fontSize: (0, _common.pxToRem)(13)
      }), _h),
      pageHeader: (_pageHeader = {
        fontFamily: defaultFontFamily,
        fontWeight: 300,
        fontSize: (0, _common.pxToRem)(30)
      }, _defineProperty(_pageHeader, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: (0, _common.pxToRem)(26)
      }), _defineProperty(_pageHeader, intermediaryTheme.breakpoints.down('md'), {
        fontSize: (0, _common.pxToRem)(24)
      }), _defineProperty(_pageHeader, intermediaryTheme.breakpoints.down('sm'), {
        fontSize: (0, _common.pxToRem)(20)
      }), _defineProperty(_pageHeader, intermediaryTheme.breakpoints.down('xs'), {
        fontSize: (0, _common.pxToRem)(16)
      }), _pageHeader),
      sectionHeader: (_sectionHeader = {
        fontSize: (0, _common.pxToRem)(18),
        fontFamily: defaultFontFamily
      }, _defineProperty(_sectionHeader, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: (0, _common.pxToRem)(16)
      }), _defineProperty(_sectionHeader, intermediaryTheme.breakpoints.down('md'), {
        fontSize: (0, _common.pxToRem)(16)
      }), _defineProperty(_sectionHeader, intermediaryTheme.breakpoints.down('sm'), {
        fontSize: (0, _common.pxToRem)(14)
      }), _defineProperty(_sectionHeader, intermediaryTheme.breakpoints.down('xs'), {
        fontSize: (0, _common.pxToRem)(13)
      }), _sectionHeader),
      body1: (_body = {
        fontSize: (0, _common.pxToRem)(16)
      }, _defineProperty(_body, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: (0, _common.pxToRem)(16)
      }), _defineProperty(_body, intermediaryTheme.breakpoints.down('md'), {
        fontSize: (0, _common.pxToRem)(12)
      }), _body),
      body2: (_body2 = {
        fontSize: (0, _common.pxToRem)(12)
      }, _defineProperty(_body2, intermediaryTheme.breakpoints.down('lg'), {
        fontSize: (0, _common.pxToRem)(12)
      }), _defineProperty(_body2, intermediaryTheme.breakpoints.down('md'), {
        fontSize: (0, _common.pxToRem)(12)
      }), _body2),
      loginTitle: {
        fontSize: (0, _common.pxToRem)(24),
        fontWeight: 300,
        lineHeight: '24px',
        fontFamily: defaultFontFamily,
        fontStyle: 'normal'
      },
      loginDescription: {
        fontSize: (0, _common.pxToRem)(16),
        lineHeight: '24px',
        fontFamily: defaultFontFamily,
        fontStyle: 'normal',
        fontWeight: 300
      }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1024,
        lg: 1240,
        xl: 1680,
        xxl: 1920
      },
      keys: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']
    },
    overrides: _objectSpread({
      MuiOutlinedInput: {
        root: {
          color: theme.font.primary
        }
      },
      MuiDrawer: {
        root: {
          '& .MuiDrawer-paper': {
            background: theme.content.secondary
          }
        }
      },
      MuiTableCell: {
        root: {
          borderBottom: theme.table.row.border,
          padding: '5px'
        },
        body: {
          color: theme.font.primary
        },
        stickyHeader: {
          backgroundColor: theme.title.primary,
          color: theme.font.primary
        }
      },
      MuiTableRow: {
        hover: {
          '&:hover': {
            background: "".concat(theme.table.row.hover.primary, " !important")
          }
        }
      },
      MuiToolbar: {
        root: {
          background: theme.content.primary,
          color: theme.font.primary
        }
      },
      MuiAutocomplete: {
        listbox: {
          backgroundColor: theme.table.filter.secondary,
          color: theme.font.primary
        },
        option: {
          '&[data-focus="true"]': {
            backgroundColor: theme.table.row.hover.primary
          }
        }
      },
      MuiFormControlLabel: {
        root: {
          '& .Mui-checked > .MuiIconButton-label > svg': {
            color: '#f50057 !important'
          },
          '& span': {
            color: theme.font.primary
          }
        }
      },
      MuiTableSortLabel: {
        icon: {
          color: "".concat(theme.font.secondary, " !important")
        }
      },
      MuiSkeletonRoot: {
        backgroundColor: 'rgba(248, 248, 248, 0.8)'
      }
    }, overrides)
  }));
};

exports.generateTheme = generateTheme;